"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InfoBarMessageWithCustomAction_1 = require("./InfoBarMessageWithCustomAction");
var InfoBarMessageWithShowDetailsAction_1 = require("./InfoBarMessageWithShowDetailsAction");
var mobx_react_1 = require("mobx-react");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var React = require("react");
var InfoBarMessageViewState_1 = require("../schema/InfoBarMessageViewState");
var styles = require('./InfoBarMessage.scss');
var classNames = require('classnames/bind').bind(styles);
var InfoBarMessage = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBarMessage, _super);
    function InfoBarMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textContainerRefGetter = function () {
            return _this.textContainerRef;
        };
        return _this;
    }
    InfoBarMessage.prototype.renderPart = function (part) {
        if (typeof part === 'string') {
            return part;
        }
        else if (part.text) {
            var customAction = part;
            return (React.createElement(InfoBarMessageWithCustomAction_1.default, { customAction: customAction, className: styles.link }));
        }
        else {
            var showDetailsAction = part;
            return (React.createElement(InfoBarMessageWithShowDetailsAction_1.default, tslib_1.__assign({}, showDetailsAction, { className: styles.link, detailContainerGetter: this.textContainerRefGetter })));
        }
    };
    InfoBarMessage.prototype.render = function () {
        var _this = this;
        // Set safety color binding to null if it's not a safety bar message.
        var safetyColorBinding = this.props.rank == InfoBarMessageViewState_1.InfoBarMessageRank.Safety
            ? {
                red: this.props.color == InfoBarMessageViewState_1.InfoBarMessageColor.Red,
                green: this.props.color == InfoBarMessageViewState_1.InfoBarMessageColor.Green,
                yellow: this.props.color == InfoBarMessageViewState_1.InfoBarMessageColor.Yellow,
            }
            : null;
        return (React.createElement("div", { className: classNames(styles.container, owa_controls_feature_flags_1.isControlFeatureEnabled('rp-newInfoBarUI')
                ? styles.newInfoBarUI
                : safetyColorBinding) },
            owa_controls_feature_flags_1.isControlFeatureEnabled('rp-newInfoBarUI') ? (React.createElement(Icon_1.Icon, { iconName: "Info" /* Info */, className: classNames(styles.icon, safetyColorBinding) })) : (React.createElement("div", { className: classNames(styles.bar, safetyColorBinding) })),
            React.createElement("div", { ref: function (ref) { return (_this.textContainerRef = ref); }, className: styles.textContainer }, this.props.messageParts.map(function (part, index) { return (React.createElement("span", { key: index },
                _this.renderPart(part),
                " ")); }))));
    };
    InfoBarMessage = tslib_1.__decorate([
        mobx_react_1.observer
    ], InfoBarMessage);
    return InfoBarMessage;
}(React.Component));
exports.default = InfoBarMessage;
//# sourceMappingURL=InfoBarMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-info-bar/lib/components/InfoBarMessage.js
// module id = 3107
// module chunks = 3 4 17